module.exports = __webpack_public_path__ + "img/1466031504.6e13fd38.jpg";